"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const fs = __importStar(require("fs"));
const core = __importStar(require("@actions/core"));
const actionsToolkit = __importStar(require("@docker/actions-toolkit"));
const toolkit_1 = require("@docker/actions-toolkit/lib/toolkit");
const context_1 = require("./context");
const meta_1 = require("./meta");
function setOutput(name, value) {
    core.setOutput(name, value);
    core.exportVariable(`DOCKER_METADATA_OUTPUT_${name.replace(/\W/g, '_').toUpperCase()}`, value);
}
actionsToolkit.run(
// main
() => __awaiter(void 0, void 0, void 0, function* () {
    const inputs = (0, context_1.getInputs)();
    const toolkit = new toolkit_1.Toolkit({ githubToken: inputs.githubToken });
    const context = yield (0, context_1.getContext)(inputs.context);
    const repo = yield toolkit.github.repoData();
    yield core.group(`Context info`, () => __awaiter(void 0, void 0, void 0, function* () {
        core.info(`eventName: ${context.eventName}`);
        core.info(`sha: ${context.sha}`);
        core.info(`ref: ${context.ref}`);
        core.info(`workflow: ${context.workflow}`);
        core.info(`action: ${context.action}`);
        core.info(`actor: ${context.actor}`);
        core.info(`runNumber: ${context.runNumber}`);
        core.info(`runId: ${context.runId}`);
    }));
    if (core.isDebug()) {
        yield core.group(`Webhook payload`, () => __awaiter(void 0, void 0, void 0, function* () {
            core.info(JSON.stringify(context.payload, null, 2));
        }));
    }
    const meta = new meta_1.Meta(inputs, context, repo);
    const version = meta.version;
    if (meta.version.main == undefined || meta.version.main.length == 0) {
        core.warning(`No Docker image version has been generated. Check tags input.`);
    }
    else {
        yield core.group(`Docker image version`, () => __awaiter(void 0, void 0, void 0, function* () {
            core.info(version.main || '');
        }));
    }
    setOutput('version', version.main || '');
    // Docker tags
    const tags = meta.getTags();
    if (tags.length == 0) {
        core.warning('No Docker tag has been generated. Check tags input.');
    }
    else {
        yield core.group(`Docker tags`, () => __awaiter(void 0, void 0, void 0, function* () {
            for (const tag of tags) {
                core.info(tag);
            }
        }));
    }
    setOutput('tags', tags.join(inputs.sepTags));
    // Docker labels
    const labels = meta.getLabels();
    yield core.group(`Docker labels`, () => __awaiter(void 0, void 0, void 0, function* () {
        for (const label of labels) {
            core.info(label);
        }
        setOutput('labels', labels.join(inputs.sepLabels));
    }));
    // Annotations
    const annotationsRaw = meta.getAnnotations();
    const annotationsLevels = process.env.DOCKER_METADATA_ANNOTATIONS_LEVELS || 'manifest';
    yield core.group(`Annotations`, () => __awaiter(void 0, void 0, void 0, function* () {
        const annotations = [];
        for (const level of annotationsLevels.split(',')) {
            annotations.push(...annotationsRaw.map(label => {
                const v = `${level}:${label}`;
                core.info(v);
                return v;
            }));
        }
        setOutput(`annotations`, annotations.join(inputs.sepAnnotations));
    }));
    // JSON
    const jsonOutput = meta.getJSON(annotationsLevels.split(','));
    yield core.group(`JSON output`, () => __awaiter(void 0, void 0, void 0, function* () {
        core.info(JSON.stringify(jsonOutput, null, 2));
        setOutput('json', JSON.stringify(jsonOutput));
    }));
    // Bake files
    for (const kind of ['tags', 'labels', 'annotations:' + annotationsLevels]) {
        const outputName = kind.split(':')[0];
        const bakeFile = meta.getBakeFile(kind);
        yield core.group(`Bake file definition (${outputName})`, () => __awaiter(void 0, void 0, void 0, function* () {
            core.info(fs.readFileSync(bakeFile, 'utf8'));
            setOutput(`bake-file-${outputName}`, bakeFile);
        }));
    }
    // Bake file with tags and labels
    setOutput(`bake-file`, `${meta.getBakeFileTagsLabels()}`);
}));
